import React from 'react';
import { Input } from 'components/atoms/input';
import { HideIfNotAllowed } from 'components/organisms/permission-controller';
import { PermissionRuleName } from 'constant';
import { useTranslate } from 'hooks/use-translation';
import { MenuGroup } from './menu-group/menu-group';
import {
  SearchContainer,
  SidebarWrapper,
  SpaceDivider,
} from './sidebar.styles';
import { SpaceSidebarTypes } from './sidebar.types';
import { useSidebarData } from './use-sidebar-data';

const PRIVATE_SPACES = 'private_spaces';
const SHARED_SPACES = 'shared_spaces';

const Component = ({
  project,
  activeSpaceId,
  activeSpaceTabId,
  projectSpaces = [],
  onSpaceAdd,
}: SpaceSidebarTypes) => {
  const translate = useTranslate();

  const { privateSpaces, sharedSpaces, onSearch } = useSidebarData({
    projectSpaces,
  });

  return (
    <SidebarWrapper>
      <SearchContainer>
        <Input
          allowClear
          size="small"
          placeholder={translate('projects.spaces.search.text')}
          onChange={(e) => onSearch(e.target.value)}
        />
      </SearchContainer>

      <HideIfNotAllowed ruleName={PermissionRuleName.SpacePrivateSection}>
        <MenuGroup
          title={translate('projects.spaces.private')}
          tooltipTitle={translate('space.private.add')}
          projectSpaces={privateSpaces}
          project={project}
          activeSpaceId={activeSpaceId}
          key={PRIVATE_SPACES}
          activeSpaceTabId={activeSpaceTabId}
          onSpaceAdd={() => onSpaceAdd(true)}
          isPrivate
          data-cy="projects.spaces.private"
        />
        <SpaceDivider />
      </HideIfNotAllowed>

      <MenuGroup
        title={translate('projects.spaces.shared')}
        tooltipTitle={translate('space.shared.add')}
        onSpaceAdd={() => onSpaceAdd(false)}
        projectSpaces={sharedSpaces}
        project={project}
        activeSpaceId={activeSpaceId}
        activeSpaceTabId={activeSpaceTabId}
        key={SHARED_SPACES}
        isPrivate={false}
        data-cy="projects.spaces.shared"
      />
    </SidebarWrapper>
  );
};

export const SpacesSidebar = React.memo(Component);
